<template>
    <div class="row">
        <div class="col-md-12">
            <h4>Add a Product</h4>
            <el-input v-model="addProductInput"
                      @change.native="searchHandle()"
                      :disabled="disabled"
                      type="text"
                      placeholder="Product Search"/>
        </div>
    </div>
</template>

<script>
  import {mapActions, mapState, mapGetters, mapMutations} from 'vuex';
  import {
    ORDER_PRODUCTS_SEARCH,
    ORDER_SET_PRODUCTS_SEARCH,
    ORDER_GET_DISABLED_STATUS_AP,
  } from '../../../store/types';

  export default {
    name: 'OrderProductSearch',
    inject: ['$v'],
    computed: {
      ...mapState({
        getSearch: state => state.order.products.search,
      }),
      ...mapGetters({
        disabled: ORDER_GET_DISABLED_STATUS_AP,
      }),
      addProductInput: {
        set(value) {
          this.setSearch(value);
        },
        get() {
          return this.getSearch;
        },
      },
    },
    methods: {
      ...mapMutations({
        setSearch: ORDER_SET_PRODUCTS_SEARCH,
      }),
      ...mapActions({
        searchProduct: ORDER_PRODUCTS_SEARCH,
      }),
      searchHandle() {
        this.searchProduct();
        this.$v.products.$touch();
      },
    },
  };
</script>
